import {
  CSSProperties,
  ReactElement,
  ReactNode,
  RefObject,
  useRef
} from 'react';
import cc from 'classcat';
import { createTestId } from 'utils/helpers/create-test-id';
import { useUpdateEffect } from 'newhooks/generic/useUpdateEffect';
import './index.less';

export type Props = {
  selectedKey: string;
  style?: CSSProperties;
  onChange: (arg: string) => void;
  size: 'small' | 'middle' | 'large';
  items: Array<{
    key: string;
    title: ReactNode;
    content?: ReactNode;
  }>;
  className?: string;
};

export const HorizontalMenu = (props: Props): ReactElement => {
  const tabRef: RefObject<HTMLDivElement> = useRef(null);

  useUpdateEffect(() => {
    tabRef.current?.scrollIntoView?.({
      behavior: 'smooth',
      inline: 'center',
      block: 'center'
    });
  }, [props.selectedKey]);

  return (
    <div
      {...createTestId('horizontal-menu')}
      style={props.style}
      className={cc([
        'horizontalMenu',
        `horizontalMenu--${props.size}`,
        props.className || ''
      ])}
    >
      <div className="horizontalMenu__menu">
        {props.items.map((item, index) => (
          <div
            ref={item.key === props.selectedKey ? tabRef : null}
            key={index}
            className={cc([
              'horizontalMenu__menuItem',
              `horizontalMenu__menuItem--${props.size}`,
              {
                'horizontalMenu__menuItem--active':
                  item.key === props.selectedKey
              }
            ])}
            onClick={() => props.onChange(item.key)}
          >
            {item.title}
          </div>
        ))}
      </div>
    </div>
  );
};
